export const PAGE_SIZE_OPTIONS = [5, 10, 20];
export const DEFAULT_PAGE_SIZE = 20;